import { render, staticRenderFns } from "./BrandTraining.vue?vue&type=template&id=b3d3fc5e&scoped=true"
import script from "./BrandTraining.vue?vue&type=script&lang=js"
export * from "./BrandTraining.vue?vue&type=script&lang=js"
import style0 from "./BrandTraining.vue?vue&type=style&index=0&id=b3d3fc5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d3fc5e",
  null
  
)

export default component.exports